import { Box, Flex, Text } from '@chakra-ui/react';
import { ArticleNavigationContext } from '@bridge/navigationStore';
import { ArticleNavigationActivity } from './useArticleNavigationActivity';
import { ContextNavigationItem } from './ContextNavigationItem';
import { getArticleItems, isStateActive } from './navigationItems';
import { useTranslation } from 'react-i18next';

interface Props {
  activeState: string;
  activity: Record<string, ArticleNavigationActivity | undefined>;
  context: ArticleNavigationContext;
  isProduction: boolean;
  variantId: number;
}

export function ProductDevelopmentNavigation({
  activeState,
  activity,
  context,
  isProduction,
  variantId,
}: Props) {
  const { t } = useTranslation();

  return (
    <Box pt={3}>
      <Text
        color="navigation.contextMuted"
        fontFamily="instrumentSans"
        fontSize="11px"
        fontWeight="semibold"
        letterSpacing="0.08em"
        px={2.5}
        textTransform="uppercase"
      >
        {t('navigation.productDevelopment')}
      </Text>
      <Flex direction="column" pt={1}>
        {getArticleItems(context, variantId, isProduction).map((item) => {
          const itemActivity = activity[item.route];
          return (
            <ContextNavigationItem
              key={item.route}
              label={t(item.label as 'navigation.overview')}
              route={item.route}
              navobj={{ articleId: context.article.id, variantId }}
              active={
                context.currentVariantId === variantId &&
                isStateActive(activeState, item.route)
              }
              meta={itemActivity?.label}
              metaTone={itemActivity?.tone}
            />
          );
        })}
      </Flex>
    </Box>
  );
}
